import React, { useEffect, useState } from "react";
import { useLang } from "./Metronici18n";
import { FormattedMessage, IntlProvider } from "react-intl";
import { useSnackbar } from "notistack";
import { useSelector, useDispatch } from "react-redux";
import { fetchTranslations } from "../../redux/features/translation/translationActions";
import "@formatjs/intl-relativetimeformat/polyfill";
import { LayoutSplashScreen } from "../layout";

function extractKey(message) {
  // Regular expression to match the key part
  const regex = /"([^"]+)" for locale:/;
  const match = regex.exec(message);
  if (match && match.length > 1) {
    return match[1]; // Return the captured group, which is the key
  }
  return null; // Return null if no match is found
}

export function I18nProvider({ children }) {
  const { enqueueSnackbar } = useSnackbar();

  const dispatch = useDispatch();
  const { translations } = useSelector((state) => state.translation);

  const locale = useLang();
  const messages = translations?.[locale] || {};
  // const messages = "az";
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async function getTranslations() {
      try {
        setLoading(true);
        await dispatch(fetchTranslations());
        setLoading(false);
      } catch (err) {
        setLoading(false);
        enqueueSnackbar(
          <IntlProvider locale={locale} messages={messages} onError={() => {}}>
            <FormattedMessage id="network_error" />
          </IntlProvider>,
          { variant: "error" }
        );
      }
    })();
  }, []);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <IntlProvider
      locale={locale}
      messages={messages}
      onError={(err) => {
        if (err.includes("Missing message")) {
          const extractedKey = extractKey(err);
          console.log("MISSING TRANSLATE: ", extractedKey);
        }
      }}
    >
      {children}
    </IntlProvider>
  );
}
